import React, { useState } from 'react';
import { connect } from "react-redux";
import * as actions from "redux/actions/balanceActions";
import { Translate, I18n } from "react-redux-i18n";

//function FormDialog() {
const FormDialog = (props) => {
    // const { className, history, ...rest } = props;
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
        setValues({
            value: 1.00,
            kind: "DEBIT",
            id: props.user_id
        });
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        props.newItem(values, props.token);
        setOpen(false);
    };

    const [values, setValues] = useState({
        value: 1.00,//props.item.price ||
        kind: "DEBIT",
        //open_at: new Date().toISOString().split('T')[0],//props.item.open_at || 
        id: props.user_id
    });


    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value,
        });
    };

    return (
        <div style={{ "display": "inline" }}>
            <button className='btn btn-secondary'
                onClick={handleClickOpen}>
                <Translate value="withdrawal" />
            </button>
            {open && (
                <div className='dialog' onClose={handleClose}>
                    <div className='dialog-content'>
                           <div className='dialog-title'>  <Translate value="withdrawal" /></div>
                        <div className='dialog-content-text'>
                            Enter Value
                        </div>
                        <input
                            // margin="dense"
                            id="value"
                            name="value"
                            required="true"
                            label="Value"
                            type="number"
                            min="0.01"
                            step="0.01"
                            value={values.value}
                            onChange={handleChange}
                            // fullWidth
                            // variant="standard"
                            oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                        />
                    
                        <div className='dialog-actions'>
                            <button className='btn btn-secondary' onClick={handleClose} variant="outlined">  <Translate value="cancel" /></button>
                            <button className='btn btn-primary' onClick={handleSave} variant="outlined">  <Translate value="save" /></button>
                        </div>
                </div>
            </div>
            )}
        </div>
    );
}

function mapStateToProps(reducer) {
    //  console.log(reducer);
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

    };
}
const mapDispatchToProps = dispatch => ({
    newItem: (params, token) =>
        dispatch(actions.newItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);
